// extracted by mini-css-extract-plugin
export default {"level1":"rowClassRules_level1__7NdI0","level2":"rowClassRules_level2__cZjKD","level3":"rowClassRules_level3__-GWzd","pageBreakRow":"rowClassRules_pageBreakRow__8DQG-"};